




















































import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

import SearchBar from '@/components/common/SearchBar.vue';
import TranslationsButton from '@/components/common/TranslationsButton.vue';

import { RepositoryEntity } from '@/models/Repository';

@Component({
    name: 'Home',
    components: {
        SearchBar,
        TranslationsButton,
    },
})
export default class Home extends Vue {
    private mainStore = mainStore.context(this.$store);

    private get isLoading(): boolean {
        return this.mainStore.state.isLoading;
    }

    private get repositories(): RepositoryEntity[] {
        return this.mainStore.state.repositories;
    }

    private get totalElems(): number {
        return this.mainStore.state.total;
    }

    private get pageLength(): number {
        return this.mainStore.state.pageLength;
    }

    private get searchTerm(): string {
        return this.mainStore.state.searchTerm;
    }

    // Search
    private onSearch(searchTerm: string): void {
        this.mainStore.actions.changeSearchTerm({ searchTerm });
    }

    // Changing page
    private onPageChange(page: number): void {
        this.mainStore.actions.changePage({ page });
    }
}
